<div class="feedback-container">
  @if (!submitted) {
    <div class="feedback-header">
      <h4>Leave Feedback</h4>
      <p>We'd love to hear how we can improve the website experience</p>
      <mat-icon class="feedback-close-icon" (click)="close()">close</mat-icon>
    </div>
  }

  @if (isSubmitting) {
    <div class="loading-spinner flex-row justify-content-center">
      <div class="lds-dual-ring"></div>
    </div>
  } @else {
    <div class="feedback-body">
      @if (submitted) {
        <p class="text-center">Thank you for sharing your thoughts with us!</p>
      } @else {
        <mat-form-field>
          <textarea matInput placeholder="What if" maxlength="2000" rows="4" [(ngModel)]="feedbackDetail"></textarea>
        </mat-form-field>
        <p class="feedback-counter">{{feedbackDetail?.length ?? 0}}/2000</p>
        <div class="feedback-rating">
          @for (rating of ratings; track $index) {
            <mat-icon class="feedback-rating-star" [ngClass]="{'material-symbols-outlined': rating > (selectedRating ?? 0) }" (click)="rate(rating)">star</mat-icon>
          }
        </div>
      }
    </div>
  }
  <div class="feedback-footer">
    @if (submitted) {
      <button class="button-action-1" (click)="close()">Close</button>
    } @else {
      <button class="button-action-1"
            (click)="submit()"
            [disabled]="!canSubmit()"
            [ngClass]="{'button-action-disabled': !canSubmit()}">Submit</button>
    }
  </div>
</div>
